import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../api/client';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [currentOrg, setCurrentOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const response = await authAPI.getMe();
      setUser(response.data.user);
      setRoles(response.data.roles);
      setOrganizations(response.data.organizations);
      
      // Set current org (first org with role)
      if (response.data.organizations.length > 0) {
        setCurrentOrg(response.data.organizations[0]);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await authAPI.login(email, password);
      localStorage.setItem('token', response.data.access_token);
      await checkAuth();
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Giriş başarısız',
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setRoles([]);
    setOrganizations([]);
    setCurrentOrg(null);
    window.location.href = '/login';
  };

  const hasRole = (requiredRole) => {
    return roles.some((r) => r.role === requiredRole);
  };

  const isSuperAdmin = () => hasRole('SUPER_ADMIN');

  const hasAIPermission = () => {
    return roles.some((r) => r.role === 'SUPER_ADMIN' || r.role === 'ACCREDITATION_COACH' || r.role === 'TRAINER');
  };

  const token = localStorage.getItem('token');

  const value = {
    user,
    roles,
    organizations,
    currentOrg,
    setCurrentOrg,
    loading,
    login,
    logout,
    hasRole,
    isSuperAdmin,
    hasAIPermission,
    isAuthenticated: !!user,
    token,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
